export function addProtocolToURL(url?: string) {
  if (url) {
    url = encodeURI(url);
    if (url.indexOf("://") === -1) {
      url = `https://${url}`;
    }
  }
  return url;
}
